import React from "react";

// Backend may return the RON flag as a boolean, string or number; treat missing as false
export const isRon = (value) => value === true || value === 'true' || value === 1 || value === '1'

export const RON_LOCATION_LABEL = 'Remote Online Notarization'

const RonBadge = ({ className = '' }) => (
    <span className={`inline-block text-xs px-2 py-1 rounded-full bg-indigo-100 text-indigo-800 font-medium ${className}`} title={RON_LOCATION_LABEL}>RON</span>
)

export default RonBadge;
